<template>
  <v-card v-if="project && board && statuses">
    <v-card-title>
      <v-flex shrink>
        <v-avatar size=48>
          <img :src="logoThumbUrl" alt="Avatar">
        </v-avatar>
      </v-flex>
      <v-flex class="pl-2 subheading" >
        {{board.attributes.name}}
      </v-flex>
    </v-card-title>

    <v-card-text>
      <v-form
        ref="form"
        lazy-validation
        >
        <v-text-field
          label="Title"
          name="name"
          prepend-icon=" "
          v-model="localBoard.name"
          :maxlength="maxCharacters"
          :counter="maxCharacters"
          :rules="[rules.required]"
        ></v-text-field>

        <v-menu
          ref="menu"
          :close-on-content-click="true"
          v-model="menu"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
          @click.native.stop
          :nudge-right="40"
          >
          <v-text-field slot="activator"
            v-model="localBoard.due_on"
            label="Due on"
            prepend-icon="event"
            readonly
            clearable
          ></v-text-field>
          <v-date-picker
            v-model="localBoard.due_on"
            no-title
            scrollable
            show-current
            >
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
          </v-date-picker>
        </v-menu>

        <v-select
          v-model="localBoard.status_ids"
          :items="statuses.map((st) => {return st.attributes})"
          item-text="name"
          item-value="id"
          label="Show statuses"
          prepend-icon=" "
          multiple
          chips
          deletable-chips
          small-chips
        ></v-select>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat color="primary" @click="cancel()">Cancel</v-btn>
      <v-btn @click="updateBoard()" color="primary" :loading="busy">Update Board</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { EventBus } from '@/utilities/event-bus'

  import boardService from '@/services/board'

  export default {
    name: 'board-edit',

    props: ['project', 'board', 'statuses'],

    data () {
      return {
        maxCharacters: 100,
        localBoard: {},
        menu: false,
        busy: false,
        rules: {
          required: value => !!value || 'Required'
        }
      }
    },

    components: {
    },

    computed: {
      logoUrl () {
        return require('@/assets/largeicon.png')
      },

      logoThumbUrl () {
        if (this.project.links && this.project.links.logo_thumb_uri) {
          return (process.env.API_URL + this.project.links.logo_thumb_uri)
        } else {
          return require('@/assets/largeicon.png')
        }
      }
    },

    mounted () {
      this.initLocalBoard()
    },

    methods: {
      cancel () {
        // NOTE: roll back any changes we made (project is passed in by reference)
        this.initLocalBoard()
        EventBus.$emit('board-updated')
      },

      initLocalBoard () {
        this.localBoard = Object.assign({}, this.board.attributes)
        // we need to inject the status_ids into the object propper to use it on edit
        this.localBoard.status_ids = this.board.relationships.statuses.data.map(rel => parseInt(rel.id))
      },

      updateBoard () {
        if (this.$refs.form.validate()) {
          this.busy = true
          boardService.update(
            (data) => {
              // we need to inject the status_ids into the object propper to use it
              data.attributes.status_ids = data.relationships.statuses.data.map(rel => parseInt(rel.id))
              this.localBoard = Object.assign({}, data.attributes)
              EventBus.$emit('board-updated', data)
              this.busy = false
            },
            (err) => {
              this.busy = false
              console.log(err)
            },
            this.localBoard
          )
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/board/_edit.vue